import { Box } from "@mui/material";
import React, { useEffect } from "react";
import { CommonStyles } from "../../components/Styles";

const PrivacyPolicy = () => {
  useEffect(() => {
    const openPrivacyPolicy = () => {
      window.open("/pdf/PrivacyPolicy.pdf", "_blank");
    };

    openPrivacyPolicy();
  }, []);

  return <Box sx={[CommonStyles.ParentRootContainer]}></Box>;
};

export default PrivacyPolicy;
